import { useI18next } from "@herob191/gatsby-plugin-react-i18next";

export default function useTranslate(object = {}, field = "") {
	const { language } = useI18next();

	if (object?.es) {
		return object[language] || object.es;
	}
}
